import MoreOptionsDropdown from 'components/group-info/MoreOptionsDropdown';
import React from 'react';
import { EnrollmentPeriod, EnrollmentStage } from 'types/enrollmentService';
import { observer } from 'mobx-react-lite';

export interface StageButtonProps {
  enrollmentPeriod: EnrollmentPeriod;
}

const StageButton = observer(({ enrollmentPeriod: { stage, id } }: StageButtonProps): JSX.Element => {
  switch (stage) {
    case EnrollmentStage.SOLD:
    case EnrollmentStage.SUBMITTED:
      return <MoreOptionsDropdown stage={stage} periodId={id} />;
    case EnrollmentStage.INSTALLED:
      return <MoreOptionsDropdown stage={stage} periodId={id} />;
    default:
      return <></>;
  }
});

export default StageButton;
